// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7z-0";
export var startPickingButton = "_7z-1";